import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { cn } from '@core/utils';
export interface ContentsListFooterProps {
  className?: string;
  content?: React.ReactNode;
  niceJoinButton?: React.ReactNode;
  buttonTitle: string;
  disabled?: boolean;
  onClickContent?: () => void;
  loading?: boolean;
}
export const ContentsListFooter = t0 => {
  const $ = _c(14);
  const {
    className,
    content,
    niceJoinButton,
    buttonTitle,
    disabled: t1,
    onClickContent,
    loading
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("bg-white mt-60 flex flex-col gap-24 py-20 [&>button]:w-full [&>button]:py-24 [&>button]:text-[1rem] [&>button]:font-700", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== content) {
    t3 = content ? <div className="flex flex-col items-center gap-8 font-600 [&>h3]:m-0 [&>h3]:text-[1.25rem] [&>h3]:font-600 [&>h3]:text-Gray-900 [&>p]:m-0 [&>p]:text-[0.875rem] [&>p]:font-400 [&>p]:text-Gray-700">{content}</div> : null;
    $[2] = content;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== buttonTitle || $[5] !== disabled || $[6] !== loading || $[7] !== onClickContent) {
    t4 = <Button disabled={disabled} loading={loading} theme="primary-fill" onClick={onClickContent}>{buttonTitle}</Button>;
    $[4] = buttonTitle;
    $[5] = disabled;
    $[6] = loading;
    $[7] = onClickContent;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== niceJoinButton || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <footer className={t2}>{t3}{t4}{niceJoinButton}</footer>;
    $[9] = niceJoinButton;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};